import React, { useCallback } from "react";
import {
  Content,
  SpecLabel,
  ContentItemWrap,
  ModelName,
  SpecWrap,
} from "./elements";
import { Spec } from "../PurchasedList";

export interface Props {
  series: string;
  model: {
    name: string;
    spec: Spec[];
  }[];
  setSelectedSeries: React.Dispatch<React.SetStateAction<string>>;
  setSelectedName: React.Dispatch<React.SetStateAction<string>>;
  setSelectedSpec: React.Dispatch<any>;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PurchasedItem: React.FC<Props> = React.memo(
  ({
    series,
    model,
    setSelectedSeries,
    setSelectedName,
    setSelectedSpec,
    setIsModalOpen,
  }) => {
    const findSpecOnClick = useCallback(
      (id: number, name: string, gb: string) => {
        for (let i = 0; i < model.length; i++) {
          if (model[i].name === name) {
            for (let j = 0; j < model[i].spec.length; j++) {
              if (model[i].spec[j].id === id && model[i].spec[j].gb === gb) {
                return model[i].spec[j];
              }
            }
          }
        }
        return null;
      },
      [model]
    );

    const handleModalOpen = useCallback(
      (id: number, name: string, gb: string) => {
        const findSpec = findSpecOnClick(id, name, gb);
        setSelectedSeries(series);
        setSelectedName(name);
        setSelectedSpec(findSpec);
        setIsModalOpen(true);
      },
      [
        findSpecOnClick,
        series,
        setSelectedSeries,
        setSelectedName,
        setSelectedSpec,
        setIsModalOpen,
      ]
    );

    return (
      <Content>
        {model.map(({ name, spec }, index) => (
          <ContentItemWrap key={`model-label${index}`}>
            <ModelName>{name}</ModelName>
            <SpecWrap>
              {spec.map(({ id, gb }, index) => {
                return (
                  <SpecLabel
                    key={`spec-label${id}`}
                    onClick={() => handleModalOpen(id, name, gb)}
                  >
                    {gb}
                  </SpecLabel>
                );
              })}
            </SpecWrap>
          </ContentItemWrap>
        ))}
      </Content>
    );
  }
);

PurchasedItem.displayName = "PurchasedItem";
